import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, Heading, Text, Image } from 'components/library'
import img01 from './assets/img01.jpg'
import img02 from './assets/img02.jpg'
import img03 from './assets/img03.jpg'
import img04 from './assets/img04.jpg'
import img05 from './assets/img05.jpg'
import img06 from './assets/img06.jpg'
import img07 from './assets/img07.jpg'
import img08 from './assets/img08.jpg'
import img09 from './assets/img09.jpg'
import img10 from './assets/img10.jpg'
import './Aspect02.css'



class Aspect02 extends React.Component {
  render() {
    return (
      <div className="Chapter01-Aspect02">
        <PageContent nospacing>
          <ContentMenu
          menuOnTop
          activeHasBackground
          tabs={[
            'Borden',
            'Markeringen',
            'Verlichting',
          ]}>

            <ContentMenuTab>
              <div className="has-fowr-row">
                <div>
                  <div>
                    <Image src={img01} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Direction Sign</Heading>
                    <Text>Een direction sign geeft de richting aan voor de op het bord vermelde locatie. Op de afbeelding wordt bijvoorbeeld de richting van rijbanen D en W3 aangegeven. </Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img02} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Location Sign</Heading>
                    <Text>Een location sign geeft de locatie aan waar je je op dat moment bevindt.  Op de afbeelding zie je het location sign voor rijbaan D. </Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img03} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>No entry Sign</Heading>
                    <Text>Een no entry sign geeft aan welke locaties je niet mag betreden. Op Schiphol-Centrum zijn dit bijvoorbeeld: rijbaan E1, N9 en W6. </Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img04} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Mandatory instruction Sign</Heading>
                    <Text>Bij het zien van een mandatory instruction sign moet je verplicht stoppen. Alleen na toestemming van LVNL of Apron Control mag je het bord passeren.</Text>
                  </div>
                </div>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-fowr-row">
                <div>
                  <div>
                    <Image src={img05} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Runway Holding Position - Patroon A</Heading>
                    <Text>Deze gele markeringen vind je op alle toeritten van alle rijbanen. De strepen markeren de grens van de baan. Alleen met toestemming van LVNL of Apron Control mag je deze overschrijden.</Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img06} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Enhanced Centerline marking</Heading>
                    <Text>Deze markering bestaat uit een gele onderbroken lijn aan weerszijden van de centerline. Het geeft aan dat je een runway holding position markering patroon A nadert.</Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img07} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Sleeproute Centrum en Oost</Heading>
                    <Text>Dit wordt aangegeven met een witte ononderbroken lijn naast de gele hartlijn over ten minste de eerste 60 meter van de rijbaan bij baankruisingen en splitsingen.</Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img08} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Mandatory Instruction Marking</Heading>
                    <Text>Deze markering geeft aan dat een specifiek punt niet, óf alleen na klaring van LVNL, gepasseerd mag worden. De markering is vergelijkbaar met een mandatory instruction sign en bestaat ook uit een rode ondergrond met witte karakters.</Text>
                  </div>
                </div>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-fowr-row">
                <div>
                  <div>
                    <Image src={img09} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Runway Guard Lights</Heading>
                    <Text>Deze amberkleurige lampen knipperen afwisselend, en geven aan dat je een baankruising nadert. Ze hebben verder geen verkeersregulerende functie.</Text>
                  </div>
                </div>
                <div>
                  <div>
                    <Image src={img10} aspectRatio={55}/>
                  </div>
                  <div>
                    <Heading h3>Stopbar</Heading>
                    <Text>Deze rij rode lampen markeert de grens tussen een rijbaan en een start- en landingsbaan. Een ontstoken stopbar mag nooit overschreden worden. De stopbars bij baankruisingen op de standaard sleeproutes zijn ontstoken wanneer de baan beschikbaar is.</Text>
                  </div>
                </div>
              </div>
            </ContentMenuTab>

          </ContentMenu>

        </PageContent>
      </div>
    )
  }
}

export default Aspect02



// WEBPACK FOOTER //
// ./src/content/chapters/01/02/Aspect02.js